import { MethodPropertyModifySettingsForm } from "components/Forms/MethodPropertyModifySettingForm/MethodPropertyModifySettingsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { RequestConnectionPropertyType } from "types/enums";
import { DrawerId } from "types/models.ts";

import FormFieldData = App.Data.FormFieldData;
import ResponseConnectionPropertyData = App.Data.ResponseConnectionPropertyData;

interface MethodRequestUrlSettingDrawerProps {
    name: number;
    parentName: number;
    leadFields?: Array<FormFieldData | ResponseConnectionPropertyData>;
    propertyType: RequestConnectionPropertyType;
}

export const MethodRequestUrlSettingDrawer: FC<MethodRequestUrlSettingDrawerProps> = ({
    name,
    parentName,
    propertyType,
    leadFields,
}) => {
    const { t } = usePaldockTranslation("drawers.method-request-url-setting");
    const drawerId = DrawerId.MethodPropertyUrlSetting;

    const propertyUrlPath = `methods.${parentName}.requestConfig.requestConnectionPropertiesUrl.${name}` as const;
    return (
        <Drawer
            drawerId={drawerId}
            title={<DrawerTitle mainTitle={t("title", { name })} />}
            searchParamsToClean={[`${drawerId}-id`, `${drawerId}-propertyType`, `${drawerId}-parentName`]}
        >
            <MethodPropertyModifySettingsForm
                leadFields={leadFields}
                propertyType={propertyType}
                propertyPath={propertyUrlPath}
            />
        </Drawer>
    );
};
